import type { ExtractPropTypes } from 'vue'

export const tooltipProps = {
	flex: Boolean,
	position: {
		type: String,
		default: 'auto'
	},
	align: {
		type: String,
		default: 'auto'
	},
	color: {
		type: String,
		default: ''
	},
	width: {
		type: [Number, String],
		default: ''
	},
	lazy: {
		type: Boolean,
		default() {
			// if (this.$TouchUI && this.$TouchUI.tooltip && this.$TouchUI.tooltip.lazy === false) {
			// 	return false
			// } else {
			// 	return true
			// }
			return true
		}
	},
	closeOnBlur: {
		// 是否可以通过点击 modal 关闭 Tooltip
		type: Boolean,
		default: true
	},
	closeOnScroll: {
		// 鼠标滚动时，是否关闭 tooltip
		type: Boolean,
		default: true
	},
	delay: {
		type: [Number, String],
		default: 0
	},
	mode: {
		type: String,
		default: ''
	},
	zIndex: {
		type: Number,
		default: 0
	},
	readonly: {
		type: Boolean,
		default: true
	}
}

export type TooltipPropsProps = ExtractPropTypes<typeof tooltipProps>

export const tooltipEmits = ['beforeOpen', 'opened']

export type TooltipEmits = typeof tooltipEmits
